import { BaseConfig } from '../ServiceConfig';

export interface CovConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.CovServiceConfigData';
  url: string;
  channel: string;
  channelId: string;
  channelType: string;
}

export const CovConfigurationFields: (keyof CovConfiguration)[] = [
  'url',
  'channel',
  'channelId',
  'channelType',
];

export const BlankCovConfiguration: CovConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.CovServiceConfigData',
} as CovConfiguration;
